module.exports = __webpack_public_path__ + "img/lg_ring_g_i_null_1@3x.b5763308.png";